import { ModalHelpers } from '@/mixins/modal';
import { ConfirmationModalSettings, ModalConstants } from '@/types';

export const confirmationHelper = {
  mixins: [ModalHelpers],
  methods: {
    async hasUnsavedChangesToKeepAsync(this: any, modal: any, isDirty: boolean, message?: string): Promise<boolean> {
      if (isDirty) {
        const confirmationModalSettings: ConfirmationModalSettings = {
          okTitle: ModalConstants.unsavedChangesConfirmation
        };
        const text = message ? message : 'You have unsaved changes';
        return !(await this.showConfirmationModalAsync(modal, text, confirmationModalSettings));
      }
      return false;
    },
    async hasDeleteConfirmedAsync(this: any, modal: any, message?: string): Promise<boolean> {
      const confirmationModalSettings: ConfirmationModalSettings = {
        okTitle: ModalConstants.deleteConfirmationText
      };
      const text = message ? message : 'Are you sure you want to delete?';
      return await this.showConfirmationModalAsync(modal, text, confirmationModalSettings);
    }
  }
};
